const ValidatorErrorCode = {
    WRONG_CODE: "validator/wrong-code",
    MISSING_FIELDS: "missing-fields",
};

export default ValidatorErrorCode;
